class CalculationService {
  constructor() {
    // this.height = height;
    // this.width = width;
  }

  loadVisualizationData(data) {
    this.data = data;
  }

  getPalletCounts() {
    this.palletCounts = {};
    this.data.pallets.forEach((pallet) => {
      if (!Object.prototype.hasOwnProperty.call(this.palletCounts, pallet.name)) {
        this.palletCounts[pallet.name] = {};
        this.palletCounts[pallet.name].rounded = 0;
        this.palletCounts[pallet.name].fraction = 0;
      }
      this.palletCounts[pallet.name].rounded += 1;

      const a =
        Math.round(((pallet.usableHeight - pallet.availableHeightToTop) / pallet.usableHeight) * 100) / 100;
      this.palletCounts[pallet.name].fraction += a;
      this.palletCounts[pallet.name].fraction = Math.round(this.palletCounts[pallet.name].fraction * 100) / 100;
    });

    return this.palletCounts;
  }
}

export default CalculationService;
